import { Directive, HostBinding, Input } from '@angular/core'

@Directive({
	selector: '[highlight]',
})
export class HighlightDirective {
	@Input() isPositive: boolean = false
	@Input() isNegative: boolean = false
	@Input() isNeutral: boolean = false
	@Input() type: 'text' | 'bg' = 'text'

	@HostBinding('class.highlight') highlightClass: boolean = true

	@HostBinding('class.positive-text')
	get positiveText(): boolean {
		return this.isPositive && this.type === 'text'
	}

	@HostBinding('class.negative-text')
	get negativeText(): boolean {
		return this.isNegative && this.type === 'text'
	}

	@HostBinding('class.neutral-text')
	get neutralText(): boolean {
		return this.isNeutral && this.type === 'text'
	}

	@HostBinding('class.positive-bg')
	get positiveBg(): boolean {
		return this.isPositive && this.type === 'bg'
	}

	@HostBinding('class.negative-bg')
	get negativeBg(): boolean {
		return this.isNegative && this.type === 'bg'
	}

	@HostBinding('class.neutral-bg')
	get neutralBg(): boolean {
		return this.isNeutral && this.type === 'bg'
	}
}
